export const user = state => state.user

export const family = state => state.family

export const currentCity = state => state.currentCity

export const currentOrg = state => state.currentOrg

export const currentPac = state => state.currentPac

export const currentOrder = state => state.currentOrder

export const currentCard = state => state.currentCard

export const invoiceType = state => state.invoiceType

export const packageOrgReqs = state => state.packageOrgReqs
// export const currentOrderType = state => state.currentOrderType;

export const agreeCMBExplain = state => state.agreeCMBExplain

export const ccbDiscount = state => {
  if (typeof state.ccbDiscount !== 'boolean') {
    return JSON.parse(state.ccbDiscount)
  } else {
    return state.ccbDiscount
  }
}
